export default "__VITE_ASSET__DZntuzqd__"